import aktiaImage from '../../images/aktia.png';
import nordeaImage from '../../images/nordea.png';
import alandsbankenImage from '../../images/alandsbanken.png';
import danskebankImage from '../../images/danskebank.png';
import handelsbankenImage from '../../images/handelsbanken.png';
import omasaastopankkiImage from '../../images/omasaastopankki.png';
import osuuspankkiImage from '../../images/osuuspankki.png';
import poppankkiImage from '../../images/poppankki.png';
import saastopankkiImage from '../../images/saastopankki.png';
import spankkiImage from '../../images/spankki.png';
import mobiilivarmenneImage from '../../images/mobiilivarmenne.png';

const banksImages = {
  aktia: aktiaImage,
  nordea: nordeaImage,
  alandsbanken: alandsbankenImage,
  danskebank: danskebankImage,
  handelsbanken: handelsbankenImage,
  omasaastopankki: omasaastopankkiImage,
  osuuspankki: osuuspankkiImage,
  poppankki: poppankkiImage,
  saastopankki: saastopankkiImage,
  spankki: spankkiImage,
  mobiilivarmenne: mobiilivarmenneImage
};

export default banksImages;



// WEBPACK FOOTER //
// ./src/components/BankSelection/banksImages.js